module.exports = __webpack_public_path__ + "static/media/5-mobile.b43a3a38.jpg";